import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import type { AuthProviderProps } from "react-oidc-context";
import { App } from "./App.js";
import { appConfig } from "./env.js";
import "./styles.css";

const oidcConfig: AuthProviderProps = {
  authority: appConfig.authority,
  client_id: appConfig.clientId,
  redirect_uri: appConfig.redirectUri,
  response_type: "code",
  scope: "openid email profile",
  // Cognito's end-session endpoint lives under the hosted-UI domain and takes
  // non-standard parameters, so sign-out is driven by hand in App.tsx.
  automaticSilentRenew: true,
  /** Strip `?code=&state=` so a refresh does not replay a spent auth code. */
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </StrictMode>,
);
